const functions = {
  isStudent: (user) =>
    !!user?.roles?.includes('studentportal-support-impersonate') ||
    !!user?.studentId,
  isAdminUser: (user) => {
    const adminRoles = [
      'studentportal-support-developer',
      'studentportal-support-admin',
      'studentportal-portal-admin',
      'studentportal-links-admin',
      'studentportal-links-draft',
      'studentportal-theme-admin',
      'studentportal-support-impersonate',
      'studentportal-critical-notifications-admin',
      'studentportal-noncritical-notifications-admin',
      'studentportal-updates-admin',
      'studentportal-updates-draft',
    ];
    return !!user?.roles?.some((x) => adminRoles.includes(x));
  },
};

export default functions;
